import React, { useEffect, useState } from "react";
import { Avatar } from "@fluentui/react-components";
import { MailIcon, MoreCircleIcon, PhoneIcon } from "../../../modules/default-svg";
import { formatPhoneForTelHref, formatPhoneNumberForDisplay } from "../../../helpers/utils";

const Stakeholders = (props) => {
  const { projectDetails } = props;
  var allStakeholders = [];
  if (projectDetails.stakeholders) {
    allStakeholders = projectDetails.stakeholders;
  }
  return (
    <div>
      <div className="CustomCard p-4 sponsorsWrapper">
        <h4 className="mb-20">Stakeholders</h4>
        <div>
          {allStakeholders.length > 0 &&
            allStakeholders.map((entity, index) => (
              <div
                key={index}
                className="CustomCardWrap d-flex align-items-center justify-content-between"
              >
                <div className="d-flex align-items-center">
                  <Avatar
                    size={28}
                    color="colorful"
                    name={entity.name}
                    image={{ src: "" }}
                  />
                  <div className="ms-12">
                    <p className="mb-1 textColor3">{entity.name}</p>
                    <span className="text-sm-400">
                    <a href={`mailto:${entity.email}`}>{entity.email}</a>
                    {entity.phone && (
                      <>
                        <br/>
                        <a href={formatPhoneForTelHref(entity.phone)}>{formatPhoneNumberForDisplay(entity.phone)}</a> 
                      </>
                      )}
                    
                    </span>
                  </div>
                </div>
                <div className="d-flex align-items-center">
                  {entity.email && (
                    <span>
                    <a href={`mailto:${entity.email}`}><MailIcon /></a>
                  </span>
                  )}
                  {entity.phone && (
                    <span className="me-12 ms-12">
                    <a href={formatPhoneForTelHref(entity.phone)}><PhoneIcon /></a>
                  </span>
                  )}
                </div>
              </div>
            ))}
        </div>
      </div>
    </div>
  );
};
export default Stakeholders;
